import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { get } from 'lodash'
import { compose, pure } from 'recompose'
import moment from 'moment'
import { ModuleLoader } from 'components/loaders'

import { Module, FieldLabel, BadgesLevels } from 'components/misc'
import { ACTIVITY_SECTIONS, ACTIVITY_SECTIONS_AJ, LEVELS } from 'constants/enums'
import styles from './levelSummary.styl'

const enhance = compose(
  connect(({ auth }) => ({
    activeOrganization: auth.organization
  })),
  injectIntl,
  pure
)

class LevelSummary extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    participantId: PropTypes.number
  }

  renderSection (sectionsMap, sectionEnum) {
    const { id, label, intlKey } = sectionEnum
    const sectionData = get(sectionsMap, id)
    const lastActivityDate = get(sectionData, 'lastActivityDate')
    const dateMoment = moment(lastActivityDate)
    const dateField = dateMoment.isValid()
      ? dateMoment.fromNow()
      : lastActivityDate

    return (
      <div className="row">
        <div className="col-xs-3">
          <FieldLabel label={label} intlKey={intlKey} />
        </div>
        <div className={`col-xs-3 text--center ${styles.item}`}>
          {get(sectionData, 'hoursCompleted') || '-'}
        </div>
        <div className={`col-xs-2 text--center ${styles.item}`}>
          {lastActivityDate ? dateField : '-'}
        </div>
        <div className={`col-xs-4 text--center ${styles.item}`}>
          {get(sectionData, 'lastActivity') || '-'}
        </div>
      </div>
    )
  }

  render () {
    const {
      data = {},
      participantId
    } = this.props
    const sectionsMap = get(data, 'summary.activitySummaryMap')
    const level = get(data, 'summary.award.awardLevel')
    const loading = get(data, 'loading')

    return (
      <div>
        {loading &&
          <ModuleLoader
            moduleWidth={400}
            moduleHeight={185}
          />
        }

        {!loading &&
          <Module
            title="Level summary"
            intlKey="moduleTitle.level_summary"
            primary
            grid
          >
            <div className="row">
              <div className="col-xs-3">
                <BadgesLevels levels={[{ awardLevel: { value: level } }]} participantId={participantId} single />
              </div>
              <div className="col-xs-3 text--center">
                <FieldLabel label="Completed / Required" intlKey="table.hours_completed_required" />
              </div>
              <div className="col-xs-2 text--center">
                <FieldLabel label="Last activity" intlKey="label.last_activity" />
              </div>
              <div className="col-xs-4 text--center">
                &nbsp;
              </div>
            </div>

            {this.renderSection(sectionsMap, ACTIVITY_SECTIONS.physical)}

            {this.renderSection(sectionsMap, ACTIVITY_SECTIONS.skills)}

            {this.renderSection(sectionsMap, ACTIVITY_SECTIONS.service)}

            {this.renderSection(sectionsMap, ACTIVITY_SECTIONS_AJ.practice)}

            {this.renderSection(sectionsMap, ACTIVITY_SECTIONS_AJ.qualify)}

            {level === LEVELS.GOLD.value && this.renderSection(sectionsMap, ACTIVITY_SECTIONS.rp)}

          </Module>
        }
      </div>
    )
  }
}

export default enhance(LevelSummary)
